export const manifest = {
  screens: {
    scr_home: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_shop: { name: "Shop", route: "/shop", position: {"x":1560,"y":220} },
    scr_product: { name: "Product Detail", route: "/product/1", position: {"x":160,"y":2200} },
    scr_story: { name: "Our Story", route: "/our-story", position: {"x":160,"y":4180} },
    scr_colabs: { name: "Colabs", route: "/colabs", position: {"x":1560,"y":4180} },
    scr_contact: { name: "Contact", route: "/contact", position: {"x":2960,"y":4180} },
    scr_checkout: { name: "Checkout", route: "/checkout", position: {"x":160,"y":6160} },
  },
  sections: {
    sec_jhp6fe: { name: "Main Navigation", x: 0, y: 0, width: 2920, height: 1180 },
    sec_r28ctr: { name: "Product Detail", x: 0, y: 1980, width: 2920, height: 1180 },
    sec_u6hwdv: { name: "Company Information", x: 0, y: 3960, width: 4320, height: 1180 },
    sec_ct8noz: { name: "Checkout Flow", x: 0, y: 5940, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_jhp6fe", children: [
      { kind: "screen", id: "scr_home" },
      { kind: "screen", id: "scr_shop" },
    ] },
    { kind: "section", id: "sec_r28ctr", children: [
      { kind: "screen", id: "scr_product" },
    ] },
    { kind: "section", id: "sec_u6hwdv", children: [
      { kind: "screen", id: "scr_story" },
      { kind: "screen", id: "scr_colabs" },
      { kind: "screen", id: "scr_contact" },
    ] },
    { kind: "section", id: "sec_ct8noz", children: [
      { kind: "screen", id: "scr_checkout" },
    ] },
  ],
}
